import { WmChart, WmChartSlice } from "@watermarkinsights/ripple-react";
import { AiDataCaptureCaption } from "../AiDataCaptureCaption";
import type { BarChartPayload } from "../ai-chat-message-utils";

interface AiBarChartProps {
  payload: BarChartPayload;
}

export const AiBarChart = ({ payload }: AiBarChartProps) => {
  const { label, valueAxisLabel, valueFormat, sort, data } = payload;

  const sortedData =
    sort && sort !== "none"
      ? [...data].sort((a, b) =>
          sort === "ascending" ? a.amount - b.amount : b.amount - a.amount,
        )
      : data;

  // Stable key ensures WmChart remounts with all slices present when data changes
  const stableChartKey = sortedData
    .map((d) => `${d.barLegend}:${d.amount}`)
    .join("|");

  return (
    <div className="tcw-chart-card">
      {label && <p className="tcw-chart-label">{label}</p>}
      <div className="tcw-chart-wrapper">
        <WmChart
          key={stableChartKey}
          chartType="bar6"
          label={label ?? "Bar Chart"}
          labelPosition="none"
          valueFormat={valueFormat ?? "amount"}
          showGrid={true}
        >
          {sortedData.map((item, index) => (
            <WmChartSlice
              key={index}
              amount={String(item.amount)}
              legend={item.barLegend}
              popoverTitle={item.popoverTitle ?? item.barLegend}
              popoverText={item.popoverText}
            />
          ))}
        </WmChart>
      </div>
      {valueAxisLabel && (
        <p className="tcw-chart-axis-label">{valueAxisLabel}</p>
      )}
      <AiDataCaptureCaption />
    </div>
  );
};
